import { Box } from 'components/Box';
import { Body } from 'components/Text/Body';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { VideoThumbnailPlayer } from 'components/VideoThumbnailPlayer';
import { CmsApiVideoBlockData } from 'modules/cms/api/types/CmsApiVideo';

type Props = {
  blockIndex: number;
  data: CmsApiVideoBlockData;
  fullWidthLayout?: boolean;
};

export function CmsVideoBlock({
  blockIndex,
  data: { headline, subtitle, videoUrl },
  fullWidthLayout,
}: Props) {
  return (
    <Box>
      {(headline || subtitle) && (
        <Box mb={48}>
          {headline && (
            <RichTextHeadline textAlign={fullWidthLayout ? 'center' : 'left'}>
              {headline}
            </RichTextHeadline>
          )}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Video',
                },
              }}
              textAlign={fullWidthLayout ? 'center' : 'left'}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </Box>
      )}

      <VideoThumbnailPlayer
        videoUrl={videoUrl}
        size={{ type: 'fixed', width: 480, height: 270 }}
        largePlayButton
        thumbnailQaId="cms-embed-video"
      />
    </Box>
  );
}
